<template>
  <page-wrapper :title="title" :hasPad="true">
    <div class="container">
      <sc-button variant="danger" @click="handleClickRemove">ลบ</sc-button>
      <popup-banner-editor
        class="mt-4"
        v-model="form"
        :imageUrl="imageUrl"
      ></popup-banner-editor>
      <div class="text-right">
        <sc-button variant="primary" @click="handleClickSave">บันทึก</sc-button>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import PopupBannerEditor from "../components/PopupBannerEditor";
import { baanRueJaiClient } from "@/dependencies";
import { uploadImage, getPublicImageUrl } from "@/god";
import { DateTime } from "luxon";
import { isNil, isEmpty } from "ramda";

export default {
  components: {
    PageWrapper,
    ScButton,
    PopupBannerEditor
  },
  data() {
    const title = "รายละเอียด Popup Banner";

    return {
      title,
      form: {
        imageFile: null,
        title: "",
        publishDate: [],
        webUrl: null
      },
      imageUrl: ""
    };
  },
  created() {
    this.setup();
  },
  methods: {
    async setup() {
      this.setupData();
    },
    async setupData() {
      const {
        title,
        image_url: imageUrl,
        published_end_at,
        published_start_at,
        web_url: webUrl
      } = await this.fetchPopupBanner();
      const publishDate = [
        DateTime.fromISO(published_start_at),
        DateTime.fromISO(published_end_at)
      ];

      this.form = {
        title,
        publishDate,
        imageUrl: null,
        webUrl
      };
      this.imageUrl = imageUrl;
    },
    async handleClickSave() {
      try {
        await this.updatePopupBanner();
        this.$router.push({ name: "PopupBannerListPage" });
      } catch (err) {
        console.error(err);
        alert("ไม่สามารถสร้าง Popup Banner ได้");
      }
    },
    async handleClickRemove() {
      if (!confirm("ยืนยันการลบ")) {
        return;
      }

      try {
        await this.removePopupBanner();
        alert("ลบเรียบร้อย");
        this.$router.push({ name: "PopupBannerListPage" });
      } catch (err) {
        alert("เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง");
        console.error(err);
      }
    },
    async fetchPopupBanner() {
      const { id } = this.$route.params;
      const response = await baanRueJaiClient.admin.communications.popupBanners.get(
        id
      );

      return response.data.result;
    },
    async removePopupBanner() {
      const { id } = this.$route.params;

      await baanRueJaiClient.admin.communications.popupBanners.delete(id);
    },
    async updatePopupBanner() {
      const { id } = this.$route.params;
      const {
        title,
        imageFile,
        publishDate: publishDateForm,
        webUrl
      } = this.form;

      const [start, end] = publishDateForm;
      const publishDate = {
        start: start.toISO(),
        end: end.toISO()
      };
      const params = {
        title,
        publishDate,
        imageUrl: this.imageUrl,
        webUrl: !isNil(webUrl) && !isEmpty(webUrl) ? webUrl.trim() : null
      };

      if (imageFile) {
        const imageUrl = await this.uploadPublicImage(imageFile);
        params.imageUrl = imageUrl;
      }

      await baanRueJaiClient.admin.communications.popupBanners.put(id, params);
    },
    async uploadPublicImage(file) {
      const image = await uploadImage(file, file.name, "article");
      const { url } = await getPublicImageUrl(image);

      return url;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
</style>



// WEBPACK FOOTER //
// src/features/communications/modules/popupBanner/pages/PopupBannerDetailPage.vue